import axios from 'axios'
// Display the resource of the specified catalog.
export default {
  /**
   * Get all list of system with items
   * @returns {AxiosPromise<any>}
   */

    /**
   * Get subcaregivers_categories
   * @param {Number} category_id
   * @returns {AxiosPromise<any>}
   */
    subcaregivers_categories (category_id) {
      //alert(category_id);
      return axios.get(`list/caregiver_category/${category_id}`)
    },
  
}



// WEBPACK FOOTER //
// ./src/api/catregiver_subcategory.js